<template>
  <div :class="$attrs.class">
    <b-field :label="label"
             :type="error ? 'is-danger': null"
             :message="error ?? null"
             :custom-class="labelClass"
             :class="$attrs.class">
      <b-input :custom-class="inputClass"  v-model="modelValue" ref="input" :type="inputType"></b-input>
    </b-field>
  </div>

</template>

<script>
import { v4 as uuid } from 'uuid'

export default {
  props: {
    id: {
      type: String,
      default() {
        return `text-input-${uuid()}`
      },
    },
    type: {
      type: String,
      default: null,
    },
    inputType: {
      type: String,
      default: 'text',
    },
    error: String,
    label: String,
    value: [String, Number],
    labelClass: String,
    inputClass: String,
  },
  computed: {
    modelValue: {
      get() { return this.value },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
    inputRef() {
      return this.$refs.input.$refs.input;
    }
  },
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
    setSelectionRange(start, end) {
      this.$refs.input.setSelectionRange(start, end)
    },
  },
}
</script>
